<template>
    <div class="appointments-empty">
        <div v-if="hasTitle"
             class="appointments-empty__title">
            <slot name="title" />
        </div>
        <div v-if="hasText"
             class="appointments-empty__text">
            <slot name="text" />
        </div>
        <div v-if="hasFooter"
             class="appointments-empty__footer">
            <slot name="footer" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppointmentsEmpty',

    computed: {
        hasTitle() {
            return !!this.$slots?.title;
        },

        hasText() {
            return !!this.$slots?.text;
        },

        hasFooter() {
            return !!this.$slots?.footer;
        }
    }
};
</script>

<style lang="scss">
@import "AppointmentsEmpty";
</style>
